import { render } from "./CardInfoRow.vue?vue&type=template&id=64f5d1a4&ts=true"
import script from "./CardInfoRow.vue?vue&type=script&lang=ts"
export * from "./CardInfoRow.vue?vue&type=script&lang=ts"

import "./CardInfoRow.vue?vue&type=style&index=0&id=64f5d1a4&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__